import * as TYPES from "./Slides.types";

export const fetchSlides = () => ({
  types: [
    TYPES.FETCH_SLIDES,
    TYPES.FETCH_SLIDES_SUCCESS,
    TYPES.FETCH_SLIDES_FAIL,
  ],
  promise: (client) => client.get(`/slides`),
});

export const fetchSlide = (id = "") => ({
  types: [TYPES.FETCH_SLIDE, TYPES.FETCH_SLIDE_SUCCESS, TYPES.FETCH_SLIDE_FAIL],
  promise: (client) => client.get(`/slides/${id}`),
});

export const fetchSponsors = () => ({
  types: [
    TYPES.FETCH_SPONSORS,
    TYPES.FETCH_SPONSORS_SUCCESS,
    TYPES.FETCH_SPONSORS_FAIL,
  ],
  promise: (client) => client.get(`/sponsors`),
});
